<template>
  <a-form
    class="mod-form mod-step3"
    layout="horizontal"
    labelAlign="left"
    :label-col="labelCol"
    :wrapper-col="wrapperCol"
    :colon="false"
    :form="form"
    @submit="onSubmit"
  >
    <a-form-item label="新密码">
      <a-input
        size="large"
        placeholder="请输入新密码"
        type="password"
        v-decorator="[
          'password',
          {
            rules: [
              {
                validator: handleFieldValidate
              }
            ],
            validateTrigger: 'blur'
          }
        ]"
      >
      </a-input>
    </a-form-item>
    <a-form-item label="确认新密码">
      <a-input
        size="large"
        placeholder="请再次输入新密码"
        type="password"
        v-decorator="[
          'confirmPassword',
          {
            rules: [
              {
                validator: handleFieldValidate
              }
            ],
            validateTrigger: 'blur'
          }
        ]"
      >
      </a-input>
    </a-form-item>
    <a-form-item :wrapper-col="wrapperColOffset">
      <a-button style="margin: 0; width: 100%" type="primary" size="large" :loading="loading" html-type="submit">提交</a-button>
    </a-form-item>
  </a-form>
</template>

<script>
import { validate } from '@/utils/validate'
import { forgetPasswordReset } from '@/api/login'

export default {
  props: {
    token: String,
    checkedToken: String
  },
  data () {
    return {
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 19
      },
      wrapperColOffset: {
        span: 19, offset: 5
      },
      form: this.$form.createForm(this),
      loading: false
    }
  },
  methods: {
    handleFieldValidate (rule, value, callback) {
      validate('forget-password-reset', this.form.getFieldsValue(), rule.fullField).then(({ valid, error }) => {
        if (valid) {
          callback()
        } else {
          callback(error)
        }
      })
    },
    onSubmit (e) {
      e.preventDefault()

      this.form.validateFields(async (errors, values) => {
        if (!errors) {
          try {
            const { token, checkedToken } = this
            this.loading = true
            await forgetPasswordReset({
              newPass: values.password,
              type: 0,
              userInfoCheckedToken: token,
              checkedToken
            })

            this.$success({
              content: '重置密码成功！',
              centered: true,
              onOk: () => {
                this.$router.replace('/login')
              }
            })
          } catch (err) {
            this.$error({
              content: err.message,
              centered: true
            })
            this.loading = false
          }
        }
      })
    }
  }
}
</script>
